import React from "react";
import { toast } from "sonner";

import { extractFromAutobio } from "../../../api/minisite";
import HeroEditor from "../editors/HeroEditor";
import IntroEditor from "../editors/IntroEditor";
import AdjectifsEditor from "../editors/AdjectifsEditor";
import ChaptersEditor from "../editors/ChaptersEditor";
import InterludesEditor from "../editors/InterludesEditor";
import ConclusionEditor from "../editors/ConclusionEditor";
import FooterEditor from "../editors/FooterEditor";
import CommentsEditor from "../editors/CommentsEditor";

export default function EditionTab({ clientId, draft, onChange, onExtracted }) {
  const update = (patch) => onChange({ ...draft, ...patch });

  const handleExtract = async () => {
    if (draft.chapters?.length && !window.confirm("Écraser le draft actuel ?")) return;
    try {
      await extractFromAutobio(clientId, true);
      // L'endpoint ne renvoie pas le draft : on le recharge depuis la DB pour
      // que les chapitres/adjectifs fraîchement extraits s'affichent.
      if (onExtracted) await onExtracted();
      toast.success("Extraction terminée");
    } catch (e) {
      toast.error("Échec de l'extraction : " + (e?.response?.data?.detail || e.message));
    }
  };

  return (
    <div>
      <button onClick={handleExtract} style={{ marginBottom: 16 }}>
        Pré-remplir depuis l'autobio (LLM)
      </button>
      <HeroEditor
        clientId={clientId}
        hero={draft.hero}
        name={draft.name}
        slug={draft.slug}
        onChange={(hero) => update({ hero })}
        onNameChange={(name) => update({ name })}
        onSlugChange={(slug) => update({ slug })}
      />
      <AdjectifsEditor
        adjectifs={draft.adjectifs || []}
        onChange={(adjectifs) => update({ adjectifs })}
      />
      <IntroEditor
        introHtml={draft.intro_html || ""}
        onChange={(intro_html) => update({ intro_html })}
      />
      <ChaptersEditor
        chapters={draft.chapters || []}
        onChange={(chapters) => update({ chapters })}
      />
      <InterludesEditor
        clientId={clientId}
        interludes={draft.interludes || []}
        onChange={(interludes) => update({ interludes })}
      />
      <ConclusionEditor
        conclusionHtml={draft.conclusion_html || ""}
        onChange={(conclusion_html) => update({ conclusion_html })}
      />
      <FooterEditor
        footer={draft.footer || {}}
        onChange={(footer) => update({ footer })}
      />
      <CommentsEditor
        comments={draft.comments || { enabled: false, notify_email: "" }}
        onChange={(comments) => update({ comments })}
      />
    </div>
  );
}
